import styled from "styled-components";

export const GenrealInfo = styled.section`
  padding: 10px;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#004c7f"};
  font-size: 14px;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  padding-left: ${(props) => props.paddingLeft ?? "20px"};
  margin-bottom: ${(props) => props.marginBottom ?? "20px"};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const FlexRowHeader = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  font-weight: normal;
`;

export const HeaderTitle = styled.h2`
  color: ${(props) => props.color ?? "#00aeea"};
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  margin: ${(props) => props.margin ?? "0px"};
  justify-self: auto;
  font-weight: 700;
`;
